import React from 'react';
import '@/styles/globals.scss';
// paywall.scss styles Zephr's paywall, which is edge-injected into a body-level
// <dialog> by literal id/class (#zephr-zone-popup, #paywall-prompt, .blaize-*) —
// markup that never lives inside our React tree, so it must be a global
// stylesheet (a CSS Module's hashed classes could never match it). The rules
// are inert on pages where Zephr injects nothing.
import '@/styles/paywall.scss';
import styles from '@/styles/App.module.scss';
import type { AppProps } from 'next/app';
import { Header, Footer } from '@/shared';
import { ContextWrapper } from '@/components';
import { usePaywallFlow } from '@/hooks/usePaywallFlow';

export default function App({ Component, pageProps }: AppProps) {
  usePaywallFlow();
  return (
    <div className='parentContainer'>
      <ContextWrapper>
        <div className={styles['header-container']}>
          <div className='header-wrapper'>
            <Header />
          </div>
        </div>

        <div className='body-container'>
          <div className='body-wrapper'>
            <main className='container'>
              <Component {...pageProps} />
            </main>
            <Footer />
          </div>
        </div>
      </ContextWrapper>
    </div>
  );
}
